<script setup>
const { errors } = defineProps(['errors']);
</script>

<template>
	<div class="error" v-if="errors.length > 0">
		<p class="message" v-for="error in errors" :key="error">{{ error }}</p>
	</div>
</template>
